import React, { useMemo } from "react";
import * as yup from "yup";

import DynamicForm from "../../../../data/Axios/DynamicForm";

import { AccountsandFinanceurl } from "../../../../config";
import Swal from "sweetalert2";
import { generateAndExecuteMutation } from "../../../../data/Axios/DynamicService";

const base_url = AccountsandFinanceurl.uri;

const validationSchema = yup.object({
  categoryName: yup
    .string()
    .trim()
    .required("Category name is required"),
});

const AccountCategoryForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const companyId = parseInt(decodedToken.CompanyId);

  const fields = useMemo(() => [
    {
      name: "categoryName",
      label: "Category Name *",
      type: "text",
      gridColumn: "span 2",
      required: true,
    },
  ], []);

  const initialValues = {
    id: props.data?.id ?? "",
    categoryName: props.data?.categoryName ?? "",
    companyId: props.data?.companyId ?? companyId,
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const categoryName = values.categoryName.trim();

      const mutationData = props.isEditing
        ? {
            id: props.data.id,
            categoryName,
            companyId,
            isActive: true,
          }
        : {
            categoryName,
            companyId,
            isActive: true,
          };

      const response = await generateAndExecuteMutation(
        props.isEditing ? "updateAccountCategory" : "createAccountCategory",
        mutationData,
        props.isEditing ? "updatedCategory" : "newCategory",
        base_url
      );

      if (Object.values(response)[0] != null) {
        props.onClose();
        props.onAction();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Account category ${
            props.isEditing ? "updated" : "created"
          } successfully.`,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error.message || "Unable to save the account category. Please try again.",
      });
    }

    setSubmitting(false);
  };

  return (
    <DynamicForm
      initialValues={initialValues}
      fields={fields}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      title={props.isEditing ? "Edit Account Category" : "Create Account Category"}
      subtitle={
        props.isEditing
          ? "Edit an Existing Account Category"
          : "Create a New Account Category"
      }
    />
  );
};

export default AccountCategoryForm;
